export default __webpack_public_path__ + "static/Plate_2x2_Warm_Yellow_RGB-ce74c74f46a8f3ba3f6c2f6ba745e488.svg";